export default __webpack_public_path__ + "static/media/rocket_anim_144.e81e9def.png";